import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiNextdotjs } from "react-icons/si";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Typescript from "../../Assets/TechIcons/Typescript.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Github from "../../Assets/TechIcons/github.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import npm from "../../Assets/TechIcons/npm.svg";
import htmlSVg from "../../Assets/TechIcons/html.svg";
import CssSVg from "../../Assets/TechIcons/css.svg";
import bootstrap from "../../Assets/TechIcons/bootstrap.svg";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Javascript} alt="javascript" />
        <div className="tech-icons-text">Javascript</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Typescript} alt="typescript" />
        <div className="tech-icons-text">Typescript</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={ReactIcon} alt="react" />
        <div className="tech-icons-text">React.Js</div>
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons">
        <img src={Redux} alt="redux" />
        <div className="tech-icons-text">Redux</div>
      </Col> */}
      <Col xs={4} md={2} className="tech-icons">
        <SiNextdotjs fontSize={"24px"} />
        <div className="tech-icons-text">Next.js</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img className="imgsvg" src={Tailwind} alt="tailwind" />
        <div className="tech-icons-text">Tailwind CSS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img className="imgsvg" src={npm} alt="tailwind" />
        <div className="tech-icons-text">npm</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img className="imgsvg" src={htmlSVg} alt="tailwind" />
        <div className="tech-icons-text">Html</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img className="imgsvg" src={CssSVg} alt="tailwind" />
        <div className="tech-icons-text">Css</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img className="imgsvg" src={bootstrap} alt="tailwind" />
        <div className="tech-icons-text">bootstrap</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img  src={Git} alt="tailwind" />
        <div className="tech-icons-text">Git</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img className="imgsvg" src={Github} alt="tailwind" />
        <div className="tech-icons-text">Github</div>
      </Col>
    </Row>
  );
}

export default Techstack;
